import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { secureBucketCookieRequestedAtom } from '@/atoms/cookies';
import env from '@/env';

export const useSecureBucketAuth = (token: string) => {
  const secureBucketCookieRequested = useAtomValue(secureBucketCookieRequestedAtom);
  const setSecureBucketCookieRequested = useSetAtom(secureBucketCookieRequestedAtom);

  useEffect(() => {
    if (!token || secureBucketCookieRequested) return;

    const params = new URLSearchParams({
      Token: token,
      Forward: window.location.href,
    });

    fetch(`${env.VITE_HUDL_URL}/app/users/configure_cookie`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
      mode: 'no-cors',
    })
      .then(() => setSecureBucketCookieRequested(true))
      .catch(() => {});
  }, [token, secureBucketCookieRequested, setSecureBucketCookieRequested]);
};
